<template>
  <div id="app">
    <div class="mainContainer">
      <div class="headMain">
        <nav-component :login="login"></nav-component>
      </div>
      <div>
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import NavComponent from "@/components/NavComponent";
export default {
  components: {
    NavComponent
  },
  mounted(){
    
  },
  data() {
    return {
      login: false
    };
  },
  watch: {
    $route() {
      console.log("nav");
      if (this.$store.state.login == true) {
        this.login = true;
      }
    }
  }
};
</script>
